import { MoveEventsPortCall } from '../types/ViewModel/MoveEventsPortCall';
import { MoveEventsBerthCall } from '../types/ViewModel/MoveEventsBerthCall';
import { MoveEventsBerthCallFactory } from './MoveEventsBerthCallFactory';
import { MoveEventsPortCallBM } from '../types/BusinessModel/MoveEventsPortCallBM';

export class MoveEventsPortCallFactory {
    private moveEventsBerthCallFactory = new MoveEventsBerthCallFactory();
    constructor() {}

    public createMoveEventsPortCallItem(
        shipId: number,
        toVoyageNumber: string,
        fromPortCallId: number,
        toPortCallId: number,
        toPortId: number | null,
        moveEventsBerthCallList: MoveEventsBerthCall[]
    ): MoveEventsPortCall {
        return new MoveEventsPortCall(shipId, toVoyageNumber, fromPortCallId, toPortCallId, toPortId, moveEventsBerthCallList);
    }

    public createMoveEventsPortCallBM(moveEventsPortCall: MoveEventsPortCall, user: string): MoveEventsPortCallBM {
        const bcBMList = moveEventsPortCall.moveEventsBerthCallList.map((item) => {
            return this.moveEventsBerthCallFactory.createMoveEventsBerthCallBM(item);
        });
        return {
            shipId: moveEventsPortCall.shipId,
            toVoyageNumber: moveEventsPortCall.toVoyageNumber,
            fromPortCallId: moveEventsPortCall.fromPortCallId,
            toPortCallId: moveEventsPortCall.toPortCallId,
            toPortId: moveEventsPortCall.toPortId,
            moveEventsBerthCallList: bcBMList,
            user: user,
        };
    }
}
